import { formatToCurrency } from '@utils/formats';
import type { FC } from 'react';

type OrderDetailsBarPriceProps = {
  textOne: string;
  price: number;
  bgColor: string;
  txtColor: string;
};

const OrderDetailsBarPrice: FC<OrderDetailsBarPriceProps> = ({ textOne, price, bgColor, txtColor }) => {
  return (
    <div
      className={`flex w-full my-1 text-${txtColor} rounded-md bg-${bgColor} justify-end items-center p-1 font-bold`}
    >
      <p className="mx-2 w-[70%] text-end">{textOne}</p>
      <p className="mx-2 w-[30%] text-end">{formatToCurrency(price, 2)}</p>
    </div>
  );
};
export default OrderDetailsBarPrice;
